import type {LightboxImageEntry} from './chat-messages.types';

/**
 * Locates a clicked image in the lightbox list by (messageId, uniqueKey). Matching on uniqueKey
 * alone breaks when an image is reattached, since the copy duplicates the original's uniqueKey.
 */
export const findLightboxImageIndex = (entries: LightboxImageEntry[], messageId: string | undefined, uniqueKey: string): number => {
  return entries.findIndex((entry) => entry.messageId === messageId && entry.uniqueKey === uniqueKey);
};
